module.exports = __webpack_public_path__ + "img/goods8.3f5b02f3.jpg";